export enum HandballThrowSavedAttribute {
  SixMeter = 1039,
  NineMeter = 1040,
  Air = 1041,
  Ground = 1042,
  LeftSide = 1043,
  RightSide = 1044,
  Center = 1045,
  LeftWing = 1046,
  RightWing = 1047,
  FastAttack = 1048,
  AfterTurnover = 1049,
  DoubleSave = 1050,
  Pivot = 1051,
  Breakthrough = 1052,
}
